import React, { useContext, useEffect } from 'react';
import LoadingPage from "../library/LoadingPage";
import { actions, StateContext } from "../../state/index";
import {
  HTTP_REQUEST_TYPES,
  LOGGING,
} from "../../utils/enums";
import { logHttpError } from "../../utils/logging";
import { healthCheck } from "../../api";
import { HttpRequestException } from "../../utils/errors";

export const PerformHealthCheck = () => {
  const [applicationState, dispatch] = useContext(StateContext);
  const { configuration, healthCheckPassedOrNotRequired } = applicationState;

  useEffect(() => {
    const performHealthCheck = async () => {
      try {
        const healthCheckResponse = await healthCheck();
        dispatch(actions.setHealthCheckPassedOrNotRequired(healthCheckResponse.status === 200))
      }
      catch (error) {
        const httpRequestException = HttpRequestException(HTTP_REQUEST_TYPES.HEALTH_CHECK_FAILED, error);

        logHttpError(httpRequestException, applicationState, { event: LOGGING.EVENTS.HEALTH_CHECK_FAILED });

        dispatch(actions.modals.showHttpErrorModal(configuration, {
          errorType: httpRequestException.errorType,
          serverResponse: httpRequestException.serverResponse,
          hideIcon: true,
        }));

        return Promise.reject(error);
      }
    }

    if (!healthCheckPassedOrNotRequired) {
      performHealthCheck()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return <LoadingPage {...configuration.performHealthCheck}/>;
};

export default PerformHealthCheck;
